
import './App.css';
// import Login from './components/login/login'
import 'primeicons/primeicons.css';
import { useState, useEffect } from 'react';
import NavContext from './contexts/NavContext';
import RouterComponent from './Router';
import { CartProvider } from './contexts/CartContext'; // مسیر درست فایل را جایگزین کنید
import NotificationHandler from './components/custom/notification-handler';

const App = () => {
  const [nav, setNav] = useState('');
  const value = { nav, setNav };
  useEffect(() => {
    const handleResize = () => {
        const height = window.innerHeight;
        document.body.classList.toggle('keyboard-active', window.innerHeight < height);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
}, []);
  return (
    <NavContext.Provider value={value}>
      <NotificationHandler />
      <CartProvider>
        <RouterComponent />
      </CartProvider>
    </NavContext.Provider>
  );

  // const [deferredPrompt, setDeferredPrompt] = useState(null);
  // const [isInstallable, setIsInstallable] = useState(false);

  // useEffect(() => {
  //   const handleBeforeInstallPrompt = (e) => {
  //     // Prevent the default mini-infobar from appearing
  //     e.preventDefault();
  //     // Save the event for later use
  //     setDeferredPrompt(e);
  //     setIsInstallable(true);
  //   };

  //   // Add the event listener
  //   window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

  //   return () => {
  //     // Clean up the event listener
  //     window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
  //   };
  // }, []);

  // const handleInstallClick = () => {
  //   if (deferredPrompt) {
  //     // Show the install prompt
  //     deferredPrompt.prompt();
  //     // Wait for the user's choice
  //     deferredPrompt.userChoice.then((choiceResult) => {
  //       if (choiceResult.outcome === 'accepted') {
  //         console.log('User accepted the install prompt');
  //       } else {
  //         console.log('User dismissed the install prompt');
  //       }
  //       setDeferredPrompt(null);
  //       setIsInstallable(false); // Hide the button after action
  //     });
  //   }
  // };
  // return (
  //   <div className="App">
  //     <h1>Welcome to My PWA!</h1>
  //     {isInstallable && (
  //       <button onClick={handleInstallClick}>
  //         Install App
  //       </button>
  //     )}
  //   </div>
  // );
}

export default App;
